import { render, staticRenderFns } from "./GraphsDialog.vue?vue&type=template&id=85d70dbe&scoped=true&"
import script from "./GraphsDialog.vue?vue&type=script&lang=js&"
export * from "./GraphsDialog.vue?vue&type=script&lang=js&"
import style0 from "./GraphsDialog.vue?vue&type=style&index=0&id=85d70dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d70dbe",
  null
  
)

export default component.exports